"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompatAnimatedScroller = exports.CompatScroller = void 0;
var react_native_1 = require("react-native");
Object.defineProperty(exports, "CompatScroller", { enumerable: true, get: function () { return react_native_1.ScrollView; } });
var AnimatedScrollView = react_native_1.Animated.ScrollView;
exports.CompatAnimatedScroller = AnimatedScrollView;
//# sourceMappingURL=CompatScroller.js.map